import axios from 'axios'
import { WEBUSER_API, WITH_CREDENTIALS_CONFIG } from 'api/constants'
import { DocumentsType } from 'types'

export const getSecuremailLinks = (
  accountNumber: string,
  documentType: DocumentsType
) =>
  axios.get(
    `${WEBUSER_API}/uri/securemail?document=${documentType}&account=${accountNumber}`,
    WITH_CREDENTIALS_CONFIG
  )
